import { Component, OnInit } from '@angular/core';

import { timelineData } from './data';

@Component({
  selector: 'app-timeline',
  templateUrl: './archives.component.html',
  styleUrls: ['./archives.component.scss']
})
export class ArchivesComponent implements OnInit {

  // bread crumb items
  breadCrumbItems: Array<{}>;

  timelineData;
  constructor() { }

  ngOnInit(): void {
    this.breadCrumbItems = [{ label: 'Bibliothèque' }, { label: 'Archives', active: true }];


    this.timelineData = timelineData;
  }

}
